import * as THREE from 'three';

const LABELS: Array<[RegExp, string]> = [
  [/\/base\//, 'Corps de base…'], [/targets|macro/, 'Morphologie…'], [/skeleton|weights/, 'Squelette…'],
  [/faceunits|visemes/, 'Expressions du visage…'], [/skins\//, 'Peau…'], [/eyes\//, 'Yeux…'],
  [/eyebrows|eyelashes/, 'Sourcils et cils…'], [/hair\//, 'Coiffure…'], [/clothes\//, 'Tenue…'], [/teeth|tongue/, 'Sourire…'],
];

/** Écran de chargement avec vraie barre de progression + ETA. */
export class LoaderUI {
  private el = document.getElementById('loader')!;
  private fill = document.getElementById('loader-fill')!;
  private step = document.getElementById('loader-step')!;
  private pct = document.getElementById('loader-pct')!;
  private eta = document.getElementById('loader-eta')!;
  private start = performance.now();
  private value = 0;

  set(progress: number, label?: string) {
    this.value = Math.max(this.value, Math.min(1, progress));
    this.fill.style.width = (this.value * 100).toFixed(1) + '%';
    this.pct.textContent = Math.round(this.value * 100) + ' %';
    if (label) this.step.textContent = label;
    const elapsed = (performance.now() - this.start) / 1000;
    if (this.value > 0.05 && this.value < 1) {
      const remain = elapsed / this.value - elapsed;
      this.eta.textContent = remain < 1 ? '' : `≈ ${Math.ceil(remain)} s`;
    } else this.eta.textContent = '';
  }

  /**
   * Suit le réseau pendant une phase (fetch + textures three.js) et fait avancer la barre
   * entre `from` et `to`. Renvoie une fonction d'arrêt.
   */
  trackNetwork(from: number, to: number): () => void {
    let started = 0, finished = 0, texTotal = 0, texLoaded = 0;
    const origFetch = window.fetch;
    const bump = (url: string) => {
      const total = started + texTotal;
      const idle = finished === started && texLoaded >= texTotal;
      const label = idle ? 'Assemblage du personnage…' : LABELS.find(([re]) => re.test(url))?.[1];
      const p = total ? (finished + texLoaded) / total : 0;
      this.set(from + (to - from) * Math.min(0.98, p), label);
    };
    window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
      started++;
      bump(url);
      return origFetch(input, init).finally(() => { finished++; bump(url); });
    };
    // Textures chargées par three.js (ImageLoader) : le gestionnaire par défaut donne chargés / total.
    const mgr = THREE.DefaultLoadingManager;
    const prevStart = mgr.onStart, prevProgress = mgr.onProgress;
    mgr.onStart = (url, loaded, total) => { texLoaded = loaded; texTotal = total; bump(url); };
    mgr.onProgress = (url, loaded, total) => { texLoaded = loaded; texTotal = total; bump(url); };
    return () => {
      window.fetch = origFetch;
      mgr.onStart = prevStart; mgr.onProgress = prevProgress;
    };
  }

  done() {
    this.set(1, 'Elle est là.');
    setTimeout(() => this.el.classList.add('done'), 250);
  }

  error(msg: string) {
    this.step.textContent = msg;
    this.fill.style.background = '#c55';
  }
}
